module.exports = __webpack_public_path__ + "img/02.contractor.841ee47e.jpg";